import React, { forwardRef, useCallback, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'ncoded-component-library';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import useCallbackRef from 'hooks/useCallbackRef';
import { DropdownOption } from 'models/Dropdown';

import './ShareableLinkDocumentMobileModal.styles.scss';

type ShareableLinkDocumentMobileModalProps = {
  className?: string;
  node: DataRoomNode;
  options: DropdownOption[];
};

const ShareableLinkDocumentMobileModal: React.ForwardRefRenderFunction<
  ModalRef,
  ShareableLinkDocumentMobileModalProps
> = (props, ref) => {
  const { className, node, options } = props;

  const { name } = node || {};

  const [modal, modalRef] = useCallbackRef<ModalRef>(null);

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('shareable-link-document-mobile-modal', className);

  const closeModal = useCallback(() => modal?.close(), [modal]);

  return (
    <Modal className={classes} title={name} lockScroll={false} ref={modalRef}>
      <div className="modal-actions-row">
        {options?.map(({ label, icon, alert, onClick }) => (
          <Button
            key={label}
            variant="outline"
            className={classNames({ alert })}
            icon={icon}
            onClick={(e) => {
              onClick(e);
              closeModal();
            }}
          >
            {label}
          </Button>
        ))}
      </div>
    </Modal>
  );
};

export default forwardRef(ShareableLinkDocumentMobileModal);
